import MarkdownRenderer from "../../../components/MarkdownRenderer";
import { IMessage } from "../../../@DTO/chat";
import { useIsMobile } from "../../../utils/useIsMobile";
import getThemeColors from "../../../utils/getColorTheme";
import { useTheme } from "../../../contexts/ThemeContext";

interface AIMessageProps {
  message: IMessage;
  isLastMessage: boolean;
}

const AIMessage = ({ message, isLastMessage }: AIMessageProps) => {
  const {addTheme} = useTheme();
  const { theme } = getThemeColors(addTheme);
  const isMobile = useIsMobile();

  return (
    <section
      className="d-flex align-self-start"
      style={{
        gap: isMobile ? 16 : 20,
        maxWidth: "80%",
      }}
    >
      <div
        className="d-flex align-items-center w-100"
        style={{
          padding: "12px 20px",
          borderRadius: "8px 35px 35px 35px",
          overflowX: "auto",
          color: theme,
          border: `1px solid ${theme}`,
        }}
      >
        {/* Display the loader while the message is still empty */}
        {message?.data?.content === "" && (
          <span className="d-flex align-items-center gap-2" role="status" aria-label="Loading message">
            <i className={`bx loader-message ${addTheme === "dark" && "dark-loader"}`} />
          </span>
        )}

        {/* Display the content when the response arrives */}
        {message?.data?.content && (
          <MarkdownRenderer
            className="mb-0 markdown"
            content={message?.data?.content as string}
            data-is-request={false}
          />
        )}
      </div>
    </section>
  );
};

export default AIMessage;
